/** SPEC §18.4: bel met meldingen (vermeldingen en opmerkingen). */
import { useEffect, useRef, useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { Icoon } from './Icoon';

interface Melding { id: string; soort: string; tekst: string; link: string; door: string | null; gelezen: boolean; aangemaakt: string }

export function MeldingenBel() {
  const qc = useQueryClient();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const q = useQuery({ queryKey: ['meldingen'], queryFn: () => api.get<{ ongelezen: number; meldingen: Melding[] }>('/api/meldingen'), refetchInterval: 60000, refetchOnWindowFocus: true });
  useEffect(() => {
    if (!open) return;
    const klik = (e: MouseEvent) => !ref.current?.contains(e.target as Node) && setOpen(false);
    document.addEventListener('mousedown', klik);
    return () => document.removeEventListener('mousedown', klik);
  }, [open]);
  const gelezen = async (ids?: string[]) => {
    await api.post('/api/meldingen/gelezen', ids ? { ids } : {});
    await qc.invalidateQueries({ queryKey: ['meldingen'] });
  };
  const n = q.data?.ongelezen ?? 0;
  return (
    <div className="bb-menu" ref={ref}>
      <button className="bb-bel" onClick={() => setOpen(!open)} title={n ? `${n} ongelezen melding${n === 1 ? '' : 'en'}` : 'Meldingen'} aria-label="Meldingen">
        <Icoon naam="bell" maat={18} />
        {n > 0 && <span className="bel-teller">{n > 99 ? '99+' : n}</span>}
      </button>
      {open && (
        <div className="menu-lijst meldingen-lijst">
          <div className="rij" style={{ padding: '6px 10px' }}>
            <b className="groei">Meldingen</b>
            {n > 0 && <button className="knop klein" onClick={() => void gelezen()}>Alles gelezen</button>}
          </div>
          {(q.data?.meldingen ?? []).map((m) => (
            <button
              key={m.id}
              className={`melding${m.gelezen ? '' : ' nieuw'}`}
              onClick={() => {
                setOpen(false);
                if (!m.gelezen) void gelezen([m.id]);
                nav(m.link);
              }}
            >
              <Icoon naam={m.soort === 'VERMELDING' ? 'user' : 'message-square'} maat={16} />
              <span className="groei">
                <span className="melding-tekst">{m.tekst}</span>
                <span className="klein mute">{new Date(m.aangemaakt).toLocaleString('nl-NL', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}</span>
              </span>
            </button>
          ))}
          {q.data && !q.data.meldingen.length && <div className="klein mute" style={{ padding: '10px' }}>Geen meldingen. Je krijgt er een als iemand je noemt met @ of reageert op jouw taak of project.</div>}
        </div>
      )}
    </div>
  );
}
